import React from "react";
import { Breadcrumbs, Link, Typography, makeStyles } from "@material-ui/core";
import PageHeadingBg from "../image/pageheadbg/pageheadingbg.jpg";
import SearchInput from "./SearchInput";

const useStyles = makeStyles((theme) => ({
  pageheadingmain: {
    backgroundImage: `url(${PageHeadingBg})`,
    backgroundRepeat: "no-repeat",
    width: "100%",
    backgroundSize: "cover",
    [theme.breakpoints.down("xs")]: {
      backgroundPosition: "left center",
    },
  },
  container: {
    maxWidth: "1250px",
    margin: "0 auto",
    padding: "1rem 0rem 1.5rem 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& .MuiTypography-h2": {
      fontFamily: "'Playfair Display', serif !important",
      color: "#212121",
      fontSize: "1.5625rem",
      fontWeight: "600",
      [theme.breakpoints.down("sm")]: {
        marginBottom: 6,
      },
    },
    "& .MuiTypography-h6": {
      fontFamily: "'Playfair Display', serif !important",
      color: "#212121",
      fontWeight: "500",
      fontSize: "1rem",
      [theme.breakpoints.down("xs")]: {
        display: "none",
      },
    },
    "& .MuiTypography-colorInherit": {
      color: "#000",
      fontFamily: "'Playfair Display', serif !important",
      fontWeight: "600",
      fontSize: "0.75rem",
      [theme.breakpoints.down("xs")]: {
        fontSize: "0.625rem",
      },
    },

    "& .MuiBreadcrumbs-ol": {
      fontFamily: "'Playfair Display', serif !important",
      [theme.breakpoints.down("sm")]: {
        padding: "0px",
        fontSize: 16,
        fontFamily: "'Playfair Display', serif !important",
        fontWeight: " 400 !important",
      },
    },

    "& .MuiTypography-colorTextPrimary": {
      color: "#FF8F12",
      fontFamily: "'Playfair Display', serif !important",
      fontWeight: "600",
      fontSize: "0.75rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "1rem 1rem !important",
    },
  },
  pageheading: {
    padding: "1rem 0 2rem 0",
    [theme.breakpoints.down("xs")]: {
      padding: "1rem 0",
    },
  },
  pageheadhr: {
    margin: "0",
    width: "6rem",
    backgroundImage: "linear-gradient(90deg, #FF8008 0%, #FFC837 100%)",
    border: "0",
    height: " 0.1875rem",
  },

  SearchInput: {
    width: "25%",
  },
}));
function PageHead(props) {
  const classes = useStyles();
  const {
    Heading,
    bookDetail,
    eBookDetail,
    onlinevideoDetail,
    liveclassesDetail,
    noteDetail,
    testseriesDetail,
    notData,
    previousyearpaperDetail,
  } = props;

  return (
    <div className={classes.pageheadingmain}>
      <div className={classes.container}>
        {Heading.map((data) => (
          <div className={classes.pageheading}>
            <Typography variant="h2" component="h2">
              {bookDetail?.book_name} {eBookDetail?.ebook_name}{" "}
              {previousyearpaperDetail?.pyp_passes_name}
              {onlinevideoDetail?.video_name}
              {liveclassesDetail?.live_class_name}
              {noteDetail?.note_name}
              {testseriesDetail?.bundle_name}
              {notData?.name} {data?.headingmain}
              <hr className={classes.pageheadhr} />
            </Typography>

            <Breadcrumbs aria-label="breadcrumb" className={classes.breadcrumb}>
              <Link color="inherit" href="/">
                Home
              </Link>
              <Typography color="textPrimary"> {data.breadcrumb}</Typography>
            </Breadcrumbs>
            {/* <div className={classes.breadcrumb}>
              <Link color="inherit" href="/">
                Home /
              </Link>
              <Typography color="inherit"> {data.breadcrumb}</Typography>
            </div> */}
          </div>
        ))}
        {Heading.map((item, index) => (
          <div key={index} className={classes.SearchInput}>
            {item.search === "yes" && <SearchInput />}
          </div>
        ))}
      </div>
    </div>
  );
}
export default PageHead;
